import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid, Theme, Typography } from '@mui/material';
import {makeStyles} from '@mui/styles';
import { trackEvent, GACommonEventAction, GAEventCategory } from 'services/googleAnalytics';
import { LEGACY_FAMILY_PORTAL_URL } from 'constants/env';
import { AdminPageContainer } from 'layouts/AdminPageLayout';
import building from 'assets/images/illustrations/building.png';
import Image from 'components/medias/Image';
import BuildingPageHeader from './BuildingPageHeader';

const useStyles = makeStyles((theme : Theme) => ({
  container: {
    paddingTop: 20,
  },
  subtitle2: {
    paddingTop: 20,
    [theme.breakpoints.up('lg')]: {
      paddingTop: 100,
    },
  },
  text: {
    paddingTop: 20,
  },
}), {name: 'BuildingPage'});

const BuildingPage = () : JSX.Element => {
  const classes = useStyles();

  return (
    <AdminPageContainer>
      <BuildingPageHeader />

      <Grid
        alignItems="center"
        className={classes.container}
        container
        justifyContent="center"
      >
        <Grid item md={6}>
          <Typography variant="subtitle1">
            <FormattedMessage id="building_page.subtitle1" />
          </Typography>

          <Typography className={classes.text} variant="body1">
            <FormattedMessage id="building_page.text1" />
          </Typography>

          <Typography className={classes.subtitle2} variant="subtitle1">
            <FormattedMessage id="building_page.subtitle2" />
          </Typography>

          <Typography className={classes.text} variant="body1">
            <FormattedMessage
              id="building_page.text2"
              values={{
                a: (parts: ReactNode[]) => (
                  <>
                    <a
                      href={LEGACY_FAMILY_PORTAL_URL}
                      onClick={() =>
                        trackEvent(
                          GAEventCategory.LINK,
                          GACommonEventAction.CLICK,
                          'Ancien site famille',
                        )
                      }
                      rel="noreferrer"
                      target="_blank"
                    >
                      {parts}
                    </a>
                  </>
                ),
              }}
            />
          </Typography>
        </Grid>

        <Grid item md={6}>
          <Image src={building} width="100%" />
        </Grid>
      </Grid>
    </AdminPageContainer>
  );
};

export default BuildingPage;